import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-program-panel',
  templateUrl: './program-panel.component.html',
  styleUrls: ['./program-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('toggle', [
      state('*', style({ 'overflow-y': 'hidden' })),
      state('void', style({ 'overflow-y': 'hidden' })),
      transition('void => *', [
        style({ height: 0, 'padding-top': '0', 'padding-bottom': '0' }),
        animate('0.4s 0.5s ease-in', style({ height: '*' })),
      ]),
      transition('* => void', [
        animate('0.4s ease-out', style({ height: 0, 'padding-top': '0', 'padding-bottom': '0' })),
      ]),
    ]),
  ],
})
export class ProgramPanelComponent {
  @Input()
  program: string;

  @Input()
  size = 'big';

  @Input()
  active: boolean;
}
